import { LocalStorageKeys, RETURN_STATUSES } from 'commons';
import { Loading } from 'components';
import { getLocalStorageItem, removeLocalStorageItem } from 'helpers';
import { useReturnDetails } from 'pages/exchange-and-return/hooks';
import { useMemo, useState } from 'react';
import { ConfirmReceived, WaitingProducts } from './components';

export function StepPost() {
  const { returnDetails, validatingReturnDetails } = useReturnDetails();
  const [showStepReceived, setShowStepReceived] = useState(false);

  const storageKey = useMemo(
    () =>
      returnDetails?.protocol &&
      `${LocalStorageKeys.ConfirmExchangeAndReturnReceived}_${returnDetails.protocol}`,
    [returnDetails?.protocol]
  );

  if (validatingReturnDetails || !returnDetails) {
    return <Loading />;
  }

  const { status, protocol } = returnDetails;
  const {
    PRODUCT_RECEIVED,
    AWAITING_CUSTOMER_DROPOFF,
    AWAITING_PRODUCT_ARRIVAL,
    RETURN_CONFIRMED,
  } = RETURN_STATUSES;

  const isReceived =
    showStepReceived ||
    status === PRODUCT_RECEIVED.value ||
    status === AWAITING_CUSTOMER_DROPOFF.value ||
    status === AWAITING_PRODUCT_ARRIVAL.value;

  const { protocol: storedProtocol, action: storedAction } =
    getLocalStorageItem(storageKey as any) || {};

  const hasStoredProtocol =
    storedProtocol === protocol && storedAction === RETURN_CONFIRMED.value;

  if (hasStoredProtocol) {
    return <WaitingProducts setShowStepReceived={setShowStepReceived} />;
  }

  if (isReceived) {
    removeLocalStorageItem(storageKey as any);

    return (
      <ConfirmReceived
        returnDetails={returnDetails}
        isReceivedByCustomerInPostOfficeFlow={showStepReceived}
      />
    );
  }

  return <WaitingProducts setShowStepReceived={setShowStepReceived} />;
}
